export default "__VITE_ASSET__c4be7c7f__"